import { render, staticRenderFns } from "./Contests.vue?vue&type=template&id=682def64"
import script from "./Contests.vue?vue&type=script&lang=js"
export * from "./Contests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports